import { isEmpty } from 'lodash-es';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCommand, useSelector } from '@tdp/core';
import {
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  AnalyticsContainer,
  appDetailsSlice,
  AnalyticsV2Keys,
  selectMetricsDataPayload,
} from '@tdp/modules/apps';

import { AnalyticsDashboard } from './AnalyticsDashboard';

export const MyAppDashboardWidget: React.FC = () => {
  const getMetricsV1Data = useCommand(
    (commands) => commands.analyticsCommands.getMetricsV1Data
  );

  const { appId } = useParams();

  const app = useSelector((s) =>
    appDetailsSlice.selectors.getAppById(s, appId ?? '')
  );

  const usageByTimePeriodWidgetStatus = useSelector(
    (state) => state.analyticsWidgets[AnalyticsV2Keys.UsageByTimePeriod]
  );

  const getMetrics = useSelector((state) =>
    selectMetricsDataPayload(state, app ? app.appId : '')
  );
  const data = getMetrics?.data;

  const intl = useIntl();
  const header = intl.formatMessage({
    defaultMessage: 'My App Dashboard',
    description: 'The card title for the analytics dashboard.',
  });

  // TODO : Use v2 API to get data
  useEffect(() => {
    if (!isEmpty(app) && isEmpty(data) && app.appId) {
      getMetricsV1Data({
        appDefinitionId: app.appId,
        aggregationType: 'User',
        platform: 'All',
        operatingSystem: 'All',
        area: 'All',
      });
    }
  }, [app]);

  const isLoading = !getMetrics?.isLoadingCompleted;
  const hasFailed: boolean = getMetrics?.hasFailed === true;

  const analyticsContainerProps = {
    size: AnalyticsV2WidgetSize.Large,
    header: header,
    children: <AnalyticsDashboard data={data} />,
  };

  if (
    isLoading ||
    usageByTimePeriodWidgetStatus.status ===
    AnalyticsV2WidgetLoadingState.Loading
  ) {
    return (
      <AnalyticsContainer
        {...analyticsContainerProps}
        status={AnalyticsV2WidgetLoadingState.Loading}
      />
    );
  }

  if (hasFailed) {
    return (
      <AnalyticsContainer
        {...analyticsContainerProps}
        status={AnalyticsV2WidgetLoadingState.Error}
      />
    );
  }

  return (
    <AnalyticsContainer
      {...analyticsContainerProps}
      status={AnalyticsV2WidgetLoadingState.Loaded}
    />
  );
};
